import React, { FC } from 'react';
import SelectOptionModal from '~Components/SelectOptionModal';
import NumberInput from '~ComponentsImproved/Numpad';
import useI18n from '~Translations';

const MAX_BEEPERS_FOR_LIST = 74; // 74 is the maximum number of options that can fit in the modal without scrolling

interface Props {
  beeperList: string[];
  onSelect: (beeperId: string) => void;
  onCancel: () => void;
  isHandheld?: boolean;
}

const BeeperSelect: FC<Props> = ({ beeperList, onSelect, onCancel, isHandheld }) => {
  const { i18n } = useI18n();

  const handleSelect = (value: string | number) => {
    if (beeperList.includes(String(value))) {
      onSelect('•' + String(value));
    } else {
      onSelect(String(value));
    }
  };

  if (beeperList.length > MAX_BEEPERS_FOR_LIST || isHandheld) {
    return (
      <NumberInput
        title={i18n('Beeper.Title.Enter')}
        onSubmit={(typedDigits) => handleSelect(typedDigits)}
        onClose={onCancel}
        maxValue={9999}
      />
    );
  }

  return (
    <SelectOptionModal
      title={i18n('Beeper.Title')}
      enableCustomInput
      width="90vw"
      options={beeperList}
      onSelect={handleSelect}
      onCancel={onCancel}
    />
  );
};

export default BeeperSelect;
